import faxApi from '@/api/fax'
import sa from '@/utils/statis'
import { Input, message, Modal } from 'antd'
import oGet from 'lodash/get'
import { useObserver } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { useAppStore } from '../../../store'

const AddNoteModal = () => {
  const [loading, setLoading] = useState(false)
  const [newNote, setNewNote] = useState('')

  const appStore = useAppStore()

  useEffect(() => {
    if (appStore.isShowAddNote && appStore.noteActiveFaxLog) {
      setNewNote(appStore.noteActiveFaxLog.note)
    } else {
      setNewNote('')
    }
  }, [appStore.isShowAddNote, appStore.noteActiveFaxLog])

  const handleNote = async () => {
    const faxLogId = oGet(appStore.noteActiveFaxLog, 'id')
    if (!faxLogId) {
      return
    }
    setLoading(true)
    try {
      await faxApi.faxNote(faxLogId, newNote)
      appStore.noteActiveFaxLog!.setNote(newNote)
      message.success(`Successfully`)
      onCancel()
    } finally {
      setLoading(false)
    }
    sa.Track('[panel]AddNote')
  }

  const onCancel = () => {
    setNewNote('')
    appStore.closeAddNote()
  }
  return useObserver(() => {
    const visible = Boolean(appStore.isShowAddNote && appStore.noteActiveFaxLog)
    const isModify = visible && appStore.noteActiveFaxLog!.note.length > 0
    return (
      <Modal
        title={`${isModify ? 'Modify' : 'Add'} Note`}
        maskClosable={false}
        visible={visible}
        okText="Save"
        confirmLoading={loading}
        onOk={handleNote}
        onCancel={onCancel}
      >
        <Input.TextArea autoFocus value={newNote} onInput={(e: any) => setNewNote(e.target.value)}></Input.TextArea>
      </Modal>
    )
  })
}

export default AddNoteModal
